import _regeneratorRuntime from "/Users/beyond/products/bybieyang-home/by-home/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { withDefaultProps } from '../../utils/with-default-props';
import React, { useEffect, useRef } from 'react';
import { useLockFn, usePersistFn } from 'ahooks';
import { withNativeProps } from '../../utils/native-props';
import { getScrollParent } from '../../utils/get-scroll-parent';
import Loading from '../loading';

function isWindow(element) {
  return element === window;
}

var classPrefix = "adm-infinite-scroll";

var InfiniteScrollContent = function InfiniteScrollContent(_ref) {
  var hasMore = _ref.hasMore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasMore ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\u52A0\u8F7D\u4E2D"), /*#__PURE__*/React.createElement(Loading, null)) : /*#__PURE__*/React.createElement("span", null, "\u6CA1\u6709\u66F4\u591A\u4E86"));
};

export var InfiniteScroll = withDefaultProps({
  threshold: 250
})(function (props) {
  var doLoadMore = useLockFn(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return props.loadMore();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  });
  var elementRef = useRef(null);
  var check = usePersistFn(function () {
    if (!props.hasMore) return;
    var element = elementRef.current;
    if (!element) return;
    var parent = getScrollParent(element);
    if (!parent) return;
    var elementTop = element.getBoundingClientRect().top;
    var current = isWindow(parent) ? window.innerHeight : parent.getBoundingClientRect().bottom;

    if (current >= elementTop - props.threshold) {
      doLoadMore();
    }
  }); // 确保在内容不足时会自动触发加载事件

  useEffect(function () {
    check();
  });
  useEffect(function () {
    var element = elementRef.current;
    if (!element) return;
    var parent = getScrollParent(element);
    if (!parent) return;

    function onScroll() {
      check();
    }

    parent.addEventListener('scroll', onScroll);
    return function () {
      parent.removeEventListener('scroll', onScroll);
    };
  }, []);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    ref: elementRef
  }, props.children && props.children, !props.children && /*#__PURE__*/React.createElement(InfiniteScrollContent, {
    hasMore: props.hasMore
  })));
});